import { render } from "./Delete_button.vue?vue&type=template&id=da911064&scoped=true"
import script from "./Delete_button.vue?vue&type=script&lang=js"
export * from "./Delete_button.vue?vue&type=script&lang=js"

import "./Delete_button.vue?vue&type=style&index=0&id=da911064&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da911064"]])

export default __exports__